export default "__VITE_ASSET__e084691d__"